import { Routes, Route } from "react-router-dom";
import Index from "./pages/Index";
import VertigoGames from "./pages/VertigoGames";
import GameDetail from "./pages/GameDetail";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import CookiePolicy from "./pages/CookiePolicy";
import FAQ from "./pages/FAQ";
import GamesOnsite from "./pages/GamesOnsite";
import ServicePage from "./pages/ServicePage";
import Kennisbank from "./pages/Kennisbank";
import ArticleDetail from "./pages/ArticleDetail";
import ThankYou from "./pages/ThankYou";
import { servicePages } from "@/data/servicePages";
import NotFound from "./pages/NotFound";

const AppRoutes = () => (
  <Routes>
    <Route path="/" element={<Index />} />
    <Route path="/experiences" element={<VertigoGames />} />
    <Route path="/experiences/:gameSlug" element={<GameDetail />} />
    <Route path="/privacy-policy" element={<PrivacyPolicy />} />
    <Route path="/terms-of-service" element={<TermsOfService />} />
    <Route path="/cookie-policy" element={<CookiePolicy />} />
    <Route path="/faq" element={<FAQ />} />
    <Route path="/games-onsite" element={<GamesOnsite />} />
    <Route path="/kennisbank" element={<Kennisbank />} />
    <Route path="/kennisbank/:articleSlug" element={<ArticleDetail />} />
    <Route path="/bedankt" element={<ThankYou />} />
    {servicePages.map((page) => (
      <Route key={page.slug} path={`/${page.slug}`} element={<ServicePage />} />
    ))}
    {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
    <Route path="*" element={<NotFound />} />
  </Routes>
);

export default AppRoutes;
